import { useEffect, useState } from "react";
import { getRandomColor } from "../../../utils";
import DropdownPair from "../../commons/DropdownPair";
import DropdownExchange from "../../commons/DropdownExchange";
import CustomSlider from "../../commons/CustomSlider";
import InputWithIcon from "../../commons/InputWithIcon";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import TokenPercentageSelector from "../../commons/TokenPercentageSelector";
import { XCircleIcon } from "@heroicons/react/24/outline";
import ToggleSwitch from "../../commons/ToggleSwitch";
import { baseAxios } from "../../../apis";

const RebalanceComponent = ({
  pairs,
  exchanges,
  selectedExchange,
  setSelectedExchange,
  selectedPair,
  setSelectedPair,
  selectedBot,
  formRebalance,
  setFormRebalance,
  loadingPair,
  loadingExchanges,
}) => {
  const percentages = ["0.5", "1", "2", "5", "10", "20", "30", "50"];
  const minutes = [
    { label: "30m", value: 30 },
    { label: "1h", value: 60 },
    { label: "4h", value: 240 },
    { label: "8h", value: 480 },
    { label: "12h", value: 720 },
    { label: "1d", value: 1440 },
    { label: "3d", value: 4320 },
    { label: "7d", value: 10080 },
    { label: "14d", value: 20160 },
    { label: "18d", value: 25920 },
  ];

  const baseCapital = 5000;

  const [percentage, setPercentage] = useState(1);
  const [percentageTakeProfit, setPercentageTakeProfit] = useState(1);
  const [capitalInput, setCapitalInput] = useState((1 / 100) * baseCapital);
  const [tokens, setTokens] = useState([]);
  const [rebalanceMethod, setRebalanceMethod] = useState(false);
  const [proportionally, setProportionally] = useState("");
  const [periodically, setPeriodically] = useState("");
  const [isTakeProfit, setIsTakeProfit] = useState(false);
  const [takeProfit, setTakeProfit] = useState((1 / 100) * capitalInput);
  const [followMarketCaps, setFollowMarketCaps] = useState([]);
  const [isFollowMarketCap, setIsFollowMarketCap] = useState(false);

  // Handle slider percentage change
  const handleSliderChange = (newPercentage) => {
    setPercentage(newPercentage);
    setCapitalInput((newPercentage / 100) * baseCapital);
  };

  // Handle manual capital input change
  const handleCapitalChange = (e) => {
    const value = e.target.value;

    if (/^\d*\.?\d*$/.test(value) && Number(value) <= baseCapital) {
      setCapitalInput(value);

      const num = parseFloat(value);
      if (!isNaN(num)) {
        const newPercentage = Math.min(
          100,
          Math.max(0, (num / baseCapital) * 100),
        );
        setPercentage(newPercentage);
      }
    }
  };

  // Add new token
  const handleAddToken = () => {
    const availablePair = pairs.find(
      (pair) => !tokens.some((token) => token.coin_name === pair.pair),
    );

    if (!availablePair) return;

    const newToken = {
      id: `${Date.now()}-${Math.random()}`,
      coin_name: availablePair.pair,
      percent: 0,
      color: getRandomColor(),
    };

    setTokens([...tokens, newToken]);
  };

  // Remove token
  const handleRemoveToken = (id) => {
    setTokens(tokens.filter((token) => token.id !== id));
  };

  // Change token coin name
  const handleTokenChange = (index, newCoin) => {
    setTokens((prevTokens) => {
      if (prevTokens.some((t, i) => i !== index && t.coin_name === newCoin)) {
        return prevTokens; // Prevent duplicates
      }

      const updated = [...prevTokens];
      updated[index] = {
        ...updated[index],
        coin_name: newCoin,
      };
      return updated;
    });
  };

  // Change token percentage
  const handlePercentChange = (index, newPercent) => {
    const updated = [...tokens];
    updated[index].percent = Number(newPercent);
    setTokens(updated);
  };

  // Calculate total percent
  const totalPercent = tokens.reduce(
    (sum, token) => sum + Number(token.percent),
    0,
  );

  // Compute capital distribution per token
  const capitalTokens = tokens.map((token) => ({
    ...token,
    capital: (capitalInput * token.percent) / 100,
  }));

  console.log("selectedpaors", selectedPair);

  // Handle manual capital input change
  const handleTakeProfitChange = (e) => {
    const value = e.target.value;

    if (/^\d*\.?\d*$/.test(value) && Number(value) <= baseCapital) {
      setTakeProfit(value);

      const num = parseFloat(value);
      if (!isNaN(num)) {
        const newPercentage = Math.min(
          100,
          Math.max(0, (num / baseCapital) * 100),
        );
        setPercentageTakeProfit(newPercentage);
      }
    }
  };

  const handleSliderTakeProfit = (newPercentage) => {
    setPercentageTakeProfit(newPercentage);
    setTakeProfit((newPercentage / 100) * capitalInput);
  };

  //   is Follow market cap

  useEffect(() => {
    if (!!isFollowMarketCap && followMarketCaps?.length) {
      setTokens(
        followMarketCaps.map((mc) => ({
          id: `${Date.now()}-${Math.random()}`,
          coin_name: mc.coin_symbol.toUpperCase() + "/USDT",
          percent: mc.allocation_percentage,
          color: getRandomColor(),
        })),
      );
    }
  }, [isFollowMarketCap, followMarketCaps]);

  useEffect(() => {
    (async function () {
      const { data } = await baseAxios.get(
        `/api/bot/rebalance/get-market-setting`,
      );

      setFollowMarketCaps(data.allocations);
    })();
  }, []);

  //
  useEffect(() => {
    setFormRebalance({
      ...formRebalance,
      settings: {
        ...formRebalance?.settings,
        capital: capitalInput,
        pattern: !rebalanceMethod ? 0 : 1,
        divergence_rate: !rebalanceMethod ? Number(proportionally) : 0,
        time_designation: !rebalanceMethod ? 0 : Number(periodically),
        take_profit_status: isTakeProfit,
        take_profit_percentage: Number(percentageTakeProfit),
        take_profit_value: Number(takeProfit),
        follow_market_cap: isFollowMarketCap,
        allocations: tokens.map((tkn) => ({
          coin_symbol: tkn.coin_name,
          allocation_percentage: tkn.percent,
        })),
      },
    });
  }, [
    tokens,
    capitalInput,
    rebalanceMethod,
    proportionally,
    periodically,
    isTakeProfit,
    takeProfit,
    percentageTakeProfit,
    isFollowMarketCap,
  ]);

  return (
    <div>
      <DropdownExchange
        id="exchange"
        value={selectedExchange}
        onChange={(val) => {
          setSelectedExchange(val);
          setSelectedPair(null);
        }}
        options={exchanges}
        loading={loadingExchanges}
      />

      <DropdownPair
        id="pair"
        value={selectedPair}
        onChange={(val) => setSelectedPair(val)}
        options={pairs}
        loading={loadingPair}
        // moreContent={
        //   <div className="p-4 px-5 border rounded-xl flex items-center justify-between bg-[#FF0000]/5 border-[#FF0000]">
        //     <div className="w-full">
        //       <div className="flex flex-col justify-between">
        //         <div className="text-base text-[#999]">Available for trade</div>
        //         <span className="text-xl font-bold">984.32 USDT</span>
        //       </div>
        //       <div className="text-sm text-[#FF0000] mt-1 ">
        //         Insufficient balance. Top up USDT or adjust Bot settings.
        //       </div>
        //     </div>
        //     <div className="flex items-center -space-x-3">
        //       <img
        //         src="/images/coins/bnb.svg"
        //         alt=""
        //         className="w-full max-w-[40px]"
        //       />
        //       <img
        //         src="/images/coins/btc.svg"
        //         alt=""
        //         className="w-full max-w-[40px]"
        //       />
        //     </div>
        //   </div>
        // }
      />

      {/*  */}
      <div className="border border-gray-300 mt-5 rounded-[10px] cursor-pointer relative p-4">
        <span className="text-[#697077] text-sm">Capital Allocation</span>

        <div className="mt-3 mb-6">
          <CustomSlider
            percentage={percentage}
            setPercentage={handleSliderChange}
          />
        </div>
        <InputWithIcon
          value={capitalInput}
          onChange={handleCapitalChange}
          placeholder="Capital Location"
          inputClassName="text-right"
          rightIcon={"USDT"}
        />
        <div className="mt-4">
          <div className="flex items-center justify-between">
            <span className="text-[#697077] text-sm">Capital Allocation</span>
            <div className="flex items-center text-sm">
              <span className="mr-3">Follow current market cap</span>
              <ToggleSwitch
                checked={isFollowMarketCap}
                onChange={() => setIsFollowMarketCap(!isFollowMarketCap)}
              />
            </div>
          </div>

          {/* Pie Chart and Token Info */}
          {!!tokens?.length && (
            <div className="block md:flex transition-all duration-300 w-full mt-2">
              <div className="flex justify-center w-full">
                <div className="flex justify-around flex-col md:flex-row items-center gap-3 w-fit md:mt-0">
                  <ResponsiveContainer width={200} height={200}>
                    <PieChart>
                      <Pie
                        data={capitalTokens}
                        dataKey="capital"
                        nameKey="coin_name"
                        innerRadius={60}
                        outerRadius={90}
                        paddingAngle={2}
                      >
                        {capitalTokens.map((tkn, index) => (
                          <Cell key={index} fill={tkn.color} />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>

                  {/* Token Labels */}
                  <div className="flex flex-col gap-2 text-xs md:text-sm mb-5 md:mb-0">
                    {capitalTokens.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between gap-1"
                      >
                        <span
                          className="inline-block w-3 h-3 rounded-full"
                          style={{
                            backgroundColor: item.color,
                          }}
                        ></span>
                        <span className="w-20 text-[#21272A] font-semibold">
                          {item.coin_name}
                        </span>
                        <span className="text-[#697077] font-medium">
                          {item.capital} USDT
                        </span>
                        {/* <span className="px-2 py-0.5 w-[50px] text-center text-[#21272A] rounded-full bg-[#F2F4F8]">
                        {item.change}
                      </span> */}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Dynamic Token Percentage Selectors */}
          <div className="w-full space-y-4 mt-3">
            {tokens.map((token, index) => (
              <div key={index} className="flex items-center gap-4">
                <TokenPercentageSelector
                  token={token.coin_name}
                  percent={token.percent}
                  onChange={(value) => handlePercentChange(index, value)}
                  onTokenChange={(newCoin) => handleTokenChange(index, newCoin)}
                  options={pairs.filter(
                    (pair) =>
                      !tokens.some((token) => token.coin_name === pair.pair),
                  )}
                />
                <XCircleIcon
                  className="w-[24px] h-[24px] cursor-pointer"
                  onClick={() => handleRemoveToken(token.id)}
                />
              </div>
            ))}
          </div>

          {/* Add More Button */}
          <button
            type="button"
            className="flex justify-center w-full max-w-[250px] rounded-2xl mx-auto py-3 font-bold text-lg bg-teal-700 hover:bg-teal-800 mt-4"
            onClick={handleAddToken}
            disabled={!selectedPair}
          >
            Add {!!tokens?.length ? "more" : ""} coin
          </button>

          {/* Validation Message */}
          {totalPercent !== 100 && (
            <div className="text-sm text-[#FF0000] mt-3">
              *Please allocate a total of 100%. Current total: {totalPercent}%
            </div>
          )}
        </div>
      </div>
      {/*  */}
      <div className="border border-gray-300 mt-5 rounded-[10px] cursor-pointer relative p-4">
        <span className="text-[#697077] text-sm">Rebalance Method</span>

        <div className="flex justify-center items-center gap-2 mt-3">
          <span>Proportionally</span>
          <ToggleSwitch
            checked={rebalanceMethod}
            onChange={() => setRebalanceMethod(!rebalanceMethod)}
          />
          <span>Periodically</span>
        </div>
        {/* percentage */}
        <div className="grid grid-cols-4 gap-4 mt-4">
          {percentages.map((percent, index) => (
            <div
              key={index}
              className={`w-full text-sm bg-[#F2F4F8] p-4 py-3 text-center rounded-xl ${
                !rebalanceMethod ? "" : "opacity-60 cursor-default"
              } ${
                percent === proportionally ? "!bg-[#007A78] text-white" : ""
              }`}
              onClick={() => setProportionally(percent)}
            >
              {percent}%
            </div>
          ))}
        </div>
        {/* end percentage */}
        {/* end minutes */}
        <div className="grid grid-cols-5 gap-4 mt-4">
          {minutes.map((minute, index) => (
            <div
              key={index}
              className={`w-full text-sm bg-[#F2F4F8] p-4 py-3 text-center rounded-xl ${
                rebalanceMethod ? "" : "opacity-60 cursor-default"
              } ${
                minute.value === periodically ? "!bg-[#007A78] text-white" : ""
              }`}
              onClick={() => setPeriodically(minute.value)}
            >
              {minute.label}
            </div>
          ))}
        </div>
        {/* end minutes */}
        <div className="flex items-center justify-between mt-6">
          <span>Take Profit</span>
          <div className="flex items-center gap-2 mt-3">
            <span>OFF</span>
            <ToggleSwitch
              checked={isTakeProfit}
              onChange={() => setIsTakeProfit(!isTakeProfit)}
            />
            <span>ON</span>
          </div>
        </div>

        <div
          className={`mt-6 ${
            !isTakeProfit && "pointer-events-none opacity-50 cursor-default"
          }`}
        >
          <CustomSlider
            percentage={percentageTakeProfit}
            setPercentage={handleSliderTakeProfit}
          />
          <InputWithIcon
            onChange={handleTakeProfitChange}
            value={takeProfit}
            placeholder="Capital Location"
            inputClassName="text-right"
            className="mt-5"
            rightIcon={"USDT"}
          />
        </div>
      </div>
    </div>
  );
};

export default RebalanceComponent;
